/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { WorkAreaDto } from '../model'
/**
 * WorkAreasApi - axios parameter creator
 */
export const WorkAreasApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkAreas`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * WorkAreasApi - functional programming interface
 */
export const WorkAreasApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WorkAreasApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkAreaDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(carrierVisitId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkAreasApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * WorkAreasApi - factory interface
 */
export const WorkAreasApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = WorkAreasApiFp(configuration)
  return {
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<WorkAreaDto>> {
      return localVarFp.get(carrierVisitId, options).then(request => request(axios, basePath))
    },
  }
}

/**
 * WorkAreasApi - object-oriented interface
 */
export class WorkAreasApi extends BaseAPI {
  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(carrierVisitId?: number, options?: RawAxiosRequestConfig) {
    return WorkAreasApiFp(this.configuration)
      .get(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
